import React, { useEffect, useState } from "react";

const ScrollBtn = () => {
  const [visible, Setvisible] = useState(false);

  function Scroll() {
    if (window.scrollY > 500) {
      Setvisible(true);
    } else {
      Setvisible(false);
    }
  }

  useEffect(() => {
    document.addEventListener("scroll", Scroll);
    document.documentElement.classList.remove("smooth-scroll");
    return () => document.removeEventListener("scroll", Scroll);
  }, [visible]);

  const goToTop = () => {
    document.documentElement.classList.add("smooth-scroll");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className={visible ? "show" : "scroll-up-btn"} onClick={goToTop}>
        <i className="fas fa-angle-up"></i>
      </div>
    </>
  );
};

export default ScrollBtn;
